module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "recommend-header"
  }, [_c('div', {
    staticClass: "recommend-header-one"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recommend-header-two"
  }, [(_vm.type == _vm.headType.recommendMain) ? _c('span', {
    staticClass: "recommend-header-left"
  }, [_vm._v("全部推荐")]) : _vm._e(), _vm._v(" "), (_vm.type == _vm.headType.share || _vm.type == _vm.headType.wxDetail) ? _c('span', {
    staticClass: "recommend-header-left-share"
  }, [_vm._v("商品详情")]) : _c('span', {
    staticClass: "recommend-header-left"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "recommend-header-three"
  }, [(_vm.type == _vm.headType.recommendMain) ? _c('button', {
    staticClass: "recommend-header-right-main",
    on: {
      "click": function($event) {
        _vm.goToH5Main()
      }
    }
  }, [_vm._v("返回首页")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d37da4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/ClassHeader.vue
// module id = 205
// module chunks = 2